import { SvgIcon, SvgIconProps, Box, Typography } from "@mui/material";

// CloseIcon
export function CloseIcon(props: SvgIconProps) {
    return (
        <SvgIcon {...props}>
            <path d="M12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 C17.5228475,22 22,17.5228475 22,12 C22,9.3478351 20.9464316,6.80429597 19.0710678,4.92893219 C17.195704,3.0535684 14.6521649,2 12,2 Z M14.71,13.29 C14.8993127,13.4777666 15.0057983,13.7333625 15.0057983,14 C15.0057983,14.2666375 14.8993127,14.5222334 14.71,14.71 C14.5222334,14.8993127 14.2666375,15.0057983 14,15.0057983 C13.7333625,15.0057983 13.4777666,14.8993127 13.29,14.71 L12,13.41 L10.71,14.71 C10.5222334,14.8993127 10.2666375,15.0057983 10,15.0057983 C9.73336246,15.0057983 9.4777666,14.8993127 9.29,14.71 C9.10068735,14.5222334 8.99420168,14.2666375 8.99420168,14 C8.99420168,13.7333625 9.10068735,13.4777666 9.29,13.29 L10.59,12 L9.29,10.71 C8.89787783,10.3178778 8.89787783,9.68212217 9.29,9.29 C9.68212217,8.89787783 10.3178778,8.89787783 10.71,9.29 L12,10.59 L13.29,9.29 C13.6821222,8.89787783 14.3178778,8.89787783 14.71,9.29 C15.1021222,9.68212217 15.1021222,10.3178778 14.71,10.71 L13.41,12 L14.71,13.29 Z" />
        </SvgIcon>
    );
}

// StarIcon
export function StarIcon(props: SvgIconProps) {
    return (
        <SvgIcon {...props}>
            <path d="M17.56,21 C17.4000767,21.0006435 17.2423316,20.9629218 17.1,20.89 L12,18.22 L6.9,20.89 C6.56213339,21.067663 6.15259539,21.0374771 5.8444287,20.8121966 C5.53626201,20.5869161 5.38323252,20.2058459 5.45,19.83 L6.45,14.2 L2.33,10.2 C2.06805623,9.93860108 1.9718844,9.55391377 2.08,9.2 C2.19824414,8.83742187 2.51242293,8.57366684 2.89,8.52 L8.59,7.69 L11.1,2.56 C11.2670864,2.21500967 11.6166774,1.99588989 12,1.99588989 C12.3833226,1.99588989 12.7329136,2.21500967 12.9,2.56 L15.44,7.68 L21.14,8.51 C21.5175771,8.56366684 21.8317559,8.82742187 21.95,9.19 C22.0581156,9.54391377 21.9619438,9.92860108 21.7,10.19 L17.58,14.19 L18.58,19.82 C18.652893,20.2027971 18.4967826,20.5930731 18.18,20.82 C17.9989179,20.9468967 17.7808835,21.010197 17.56,21 L17.56,21 Z" />
        </SvgIcon>
    );
}

// Using for Alert
export function InfoIcon(props: SvgIconProps) {
    return (
        <SvgIcon {...props}>
            <path d="M12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 C17.5228475,22 22,17.5228475 22,12 C22,9.3478351 20.9464316,6.80429597 19.0710678,4.92893219 C17.195704,3.0535684 14.6521649,2 12,2 Z M13,16 C13,16.5522847 12.5522847,17 12,17 C11.4477153,17 11,16.5522847 11,16 L11,11 C11,10.4477153 11.4477153,10 12,10 C12.5522847,10 13,10.4477153 13,11 L13,16 Z M12,9 C11.4477153,9 11,8.55228475 11,8 C11,7.44771525 11.4477153,7 12,7 C12.5522847,7 13,7.44771525 13,8 C13,8.55228475 12.5522847,9 12,9 Z" />
        </SvgIcon>
    );
}

export function WarningIcon(props: SvgIconProps) {
    return (
        <SvgIcon {...props}>
            <path d="M22.56,16.3 L14.89,3.58 C14.2597186,2.59400001 13.1702353,1.99737652 12,1.99737652 C10.8297647,1.99737652 9.74028139,2.59400001 9.11,3.58 L1.44,16.3 C0.888546003,17.2192471 0.869485343,18.3628867 1.39,19.3 C1.99197363,20.3551378 3.11522982,21.0046397 4.33,21 L19.67,21 C20.8765042,21.0128744 21.9978314,20.3797441 22.61,19.34 C23.146086,18.3926382 23.1269508,17.2292197 22.56,16.3 L22.56,16.3 Z M12,17 C11.4477153,17 11,16.5522847 11,16 C11,15.4477153 11.4477153,15 12,15 C12.5522847,15 13,15.4477153 13,16 C13,16.5522847 12.5522847,17 12,17 Z M13,13 C13,13.5522847 12.5522847,14 12,14 C11.4477153,14 11,13.5522847 11,13 L11,9 C11,8.44771525 11.4477153,8 12,8 C12.5522847,8 13,8.44771525 13,9 L13,13 Z" />
        </SvgIcon>
    );
}

export function SuccessIcon(props: SvgIconProps) {
    return (
        <SvgIcon {...props}>
            <path d="M12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 C17.5228475,22 22,17.5228475 22,12 C22,9.3478351 20.9464316,6.80429597 19.0710678,4.92893219 C17.195704,3.0535684 14.6521649,2 12,2 Z M16.3,9.61 L11.73,15.61 C11.5412074,15.855247 11.2494966,15.9992561 10.94,16.0000145 C10.6322197,16.001658 10.3408221,15.861492 10.15,15.62 L7.71,12.51 C7.49028166,12.2277602 7.43782669,11.8497415 7.57239438,11.5183399 C7.70696206,11.1869384 8.00810836,10.9525017 8.36239438,10.9033399 C8.7166804,10.8541782 9.07028166,10.9977602 9.29,11.28 L10.92,13.36 L14.7,8.36 C14.917932,8.07418751 15.2717886,7.92635122 15.6282755,7.97217964 C15.9847624,8.01800806 16.2897207,8.25053875 16.4282755,8.58217966 C16.5668304,8.91382056 16.517932,9.29418753 16.3,9.58 L16.3,9.61 Z" />
        </SvgIcon>
    );
}

export function ErrorIcon(props: SvgIconProps) {
    return (
        <SvgIcon {...props}>
            <path d="M12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 C17.5228475,22 22,17.5228475 22,12 C22,9.3478351 20.9464316,6.80429597 19.0710678,4.92893219 C17.195704,3.0535684 14.6521649,2 12,2 Z M12,17 C11.4477153,17 11,16.5522847 11,16 C11,15.4477153 11.4477153,15 12,15 C12.5522847,15 13,15.4477153 13,16 C13,16.5522847 12.5522847,17 12,17 Z M13,13 C13,13.5522847 12.5522847,14 12,14 C11.4477153,14 11,13.5522847 11,13 L11,8 C11,7.44771525 11.4477153,7 12,7 C12.5522847,7 13,7.44771525 13,8 L13,13 Z" />
        </SvgIcon>
    );
}

// Using for Checkbox
export function CheckboxIcon(props: SvgIconProps) {
    return (
        <SvgIcon {...props}>
            <path d="M17 3a4 4 0 014 4v10a4 4 0 01-4 4H7a4 4 0 01-4-4V7a4 4 0 014-4h10zm0 2H7a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2z" />
        </SvgIcon>
    );
}

export function CheckboxCheckedIcon(props: SvgIconProps) {
    return (
        <SvgIcon {...props}>
            <path d="M17 3a4 4 0 014 4v10a4 4 0 01-4 4H7a4 4 0 01-4-4V7a4 4 0 014-4h10zm-1.372 4.972a1.006 1.006 0 00-.928.388l-3.78 5-1.63-2.08a1.001 1.001 0 00-1.58 1.23l2.44 3.11a1 1 0 001.58-.01l4.57-6v-.03a1.006 1.006 0 00-.672-1.608z" />
        </SvgIcon>
    );
}

export function CheckboxIndeterminateIcon(props: SvgIconProps) {
    return (
        <SvgIcon {...props}>
            <path d="M17 3a4 4 0 014 4v10a4 4 0 01-4 4H7a4 4 0 01-4-4V7a4 4 0 014-4h10zm-1.75 8h-6.5a.75.75 0 00-.75.75v.5c0 .414.336.75.75.75h6.5a.75.75 0 00.75-.75v-.5a.75.75 0 00-.75-.75z" />
        </SvgIcon>
    );
}

// Using for Select Input
export function InputSelectIcon(props: SvgIconProps) {
    return (
        <SvgIcon
            {...props}
            sx={{
                right: 12,
                fontSize: 16,
                position: "absolute",
                pointerEvents: "none",
            }}
        >
            <path d="M12,16 C11.7663478,16.0004565 11.5399121,15.9190812 11.36,15.77 L5.36,10.77 C4.93474074,10.4165378 4.87653776,9.78525926 5.23,9.36 C5.58346224,8.93474074 6.21474074,8.87653776 6.64,9.23 L12,13.71 L17.36,9.39 C17.5665934,9.2222295 17.8315409,9.14373108 18.0961825,9.17188444 C18.3608241,9.2000378 18.6033268,9.33252029 18.77,9.54 C18.9551341,9.74785947 19.0452548,10.0234772 19.0186853,10.3005589 C18.9921158,10.5776405 18.8512608,10.8311099 18.63,11 L12.63,15.83 C12.444916,15.955516 12.2231011,16.0153708 12,16 Z" />
        </SvgIcon>
    );
}

//  Using for TreeView
export function TreeViewCollapseIcon(props: SvgIconProps) {
    return (
        <SvgIcon {...props}>
            <path d="M18,3 C19.6568542,3 21,4.34314575 21,6 L21,6 L21,18 C21,19.6568542 19.6568542,21 18,21 L18,21 L6,21 C4.34314575,21 3,19.6568542 3,18 L3,18 L3,6 C3,4.34314575 4.34314575,3 6,3 L6,3 Z M18,5 L6,5 C5.44771525,5 5,5.44771525 5,6 L5,6 L5,18 C5,18.5522847 5.44771525,19 6,19 L6,19 L18,19 C18.5522847,19 19,18.5522847 19,18 L19,18 L19,6 C19,5.44771525 18.5522847,5 18,5 L18,5 Z M12,8 C12.5522847,8 13,8.44771525 13,9 L13,9 L13,11 L15,11 C15.5522847,11 16,11.4477153 16,12 C16,12.5522847 15.5522847,13 15,13 L15,13 L13,13 L13,15 C13,15.5522847 12.5522847,16 12,16 C11.4477153,16 11,15.5522847 11,15 L11,15 L11,13 L9,13 C8.44771525,13 8,12.5522847 8,12 C8,11.4477153 8.44771525,11 9,11 L9,11 L11,11 L11,9 C11,8.44771525 11.4477153,8 12,8 Z" />
        </SvgIcon>
    );
}

export function TreeViewExpandIcon(props: SvgIconProps) {
    return (
        <SvgIcon {...props}>
            <path d="M18,3 C19.6568542,3 21,4.34314575 21,6 L21,6 L21,18 C21,19.6568542 19.6568542,21 18,21 L18,21 L6,21 C4.34314575,21 3,19.6568542 3,18 L3,18 L3,6 C3,4.34314575 4.34314575,3 6,3 L6,3 Z M18,5 L6,5 C5.44771525,5 5,5.44771525 5,6 L5,6 L5,18 C5,18.5522847 5.44771525,19 6,19 L6,19 L18,19 C18.5522847,19 19,18.5522847 19,18 L19,18 L19,6 C19,5.44771525 18.5522847,5 18,5 L18,5 Z M15,11 C15.5522847,11 16,11.4477153 16,12 C16,12.5522847 15.5522847,13 15,13 L15,13 L9,13 C8.44771525,13 8,12.5522847 8,12 C8,11.4477153 8.44771525,11 9,11 L9,11 Z" />
        </SvgIcon>
    );
}

export function TreeViewEndIcon(props: SvgIconProps) {
    return (
        <SvgIcon {...props}>
            <path d="M18,3 C19.6568542,3 21,4.34314575 21,6 L21,6 L21,18 C21,19.6568542 19.6568542,21 18,21 L18,21 L6,21 C4.34314575,21 3,19.6568542 3,18 L3,18 L3,6 C3,4.34314575 4.34314575,3 6,3 L6,3 Z M18,5 L6,5 C5.44771525,5 5,5.44771525 5,6 L5,6 L5,18 C5,18.5522847 5.44771525,19 6,19 L6,19 L18,19 C18.5522847,19 19,18.5522847 19,18 L19,18 L19,6 C19,5.44771525 18.5522847,5 18,5 L18,5 Z M14,8.99420168 C14.2666375,8.99420168 14.5222334,9.10068735 14.71,9.29 C14.8993127,9.4777666 15.0057983,9.73336246 15.0057983,10 C15.0057983,10.2666375 14.8993127,10.5222334 14.71,10.71 L14.71,10.71 L13.41,12 L14.71,13.29 C14.8993127,13.4777666 15.0057983,13.7333625 15.0057983,14 C15.0057983,14.2666375 14.8993127,14.5222334 14.71,14.71 C14.5222334,14.8993127 14.2666375,15.0057983 14,15.0057983 C13.7333625,15.0057983 13.4777666,14.8993127 13.29,14.71 L13.29,14.71 L12,13.41 L10.71,14.71 C10.5222334,14.8993127 10.2666375,15.0057983 10,15.0057983 C9.73336246,15.0057983 9.4777666,14.8993127 9.29,14.71 C9.10068735,14.5222334 8.99420168,14.2666375 8.99420168,14 C8.99420168,13.7333625 9.10068735,13.4777666 9.29,13.29 L9.29,13.29 L10.59,12 L9.29,10.71 C8.89787783,10.3178778 8.89787783,9.68212217 9.29,9.29 C9.68212217,8.89787783 10.3178778,8.89787783 10.71,9.29 L10.71,9.29 L12,10.59 L13.29,9.29 C13.4777666,9.10068735 13.7333625,8.99420168 14,8.99420168 Z" />
        </SvgIcon>
    );
}

// custom

export function AccountBillingIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M1.7 8.8v1.2c0 .5 2 1.7 5.8 1.7c1.8 0 3.2-0.3 4.2-0.6v1.7c-1.3 .4-2.7 .5-4.2 .5c-2.2 0-4.4-0.4-5.8-1.1v1.1c0 .5 2 1.7 5.8 1.7c1.8 0 3.2-0.3 4.2-0.6v1.7c-1.3 .4-2.7 .6-4.2 .6c-3.7 0-7.5-1.2-7.5-3.4v-10c0-2.2 3.8-3.3 7.5-3.3c3.7 0 7.5 1.1 7.5 3.3v5l-1.7 .5c-1.4 .8-3.6 1.2-5.8 1.2c-2.2 0-4.4-0.4-5.8-1.2Zm11.6-5.5c0-0.5-2-1.6-5.8-1.6c-3.8 0-5.8 1.1-5.8 1.6c0 .5 2 1.7 5.8 1.7c3.8 0 5.8-1.2 5.8-1.7Zm-5.8 3.4c-2.2 0-4.4-0.4-5.8-1.2v1.2c0 .5 2 1.6 5.8 1.6c3.8 0 5.8-1.1 5.8-1.6v-1.2c-1.4 .8-3.6 1.2-5.8 1.2Zm8.3 7.5h1.7c1.4 0 2.5 1.1 2.5 2.5c0 1.3-1.1 2.5-2.5 2.5v.8h-1.7v-0.8h-1.6v-1.7h3.3c.5 0 .8-0.4 .8-0.8c0-0.5-0.3-0.9-0.8-0.9h-1.7c-1.3 0-2.5-1.1-2.5-2.5c0-1.3 1.2-2.5 2.5-2.5v-0.8h1.7v.8h1.7v1.7h-3.4c-0.4 0-0.8 .4-0.8 .8c0 .5 .4 .9 .8 .9Z" />
        </SvgIcon>
    );
}

export function AlertIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M0 13.6v3.1h20v-3.1l-0.8-0.2c-1.5-0.5-2.5-2-2.5-3.6v-3.1c0-3.7-3-6.7-6.7-6.7c-3.7 0-6.7 3-6.7 6.7v3.1c0 1.6-1 3.1-2.5 3.6Zm16.6 .8h-13.2c1.3-1.1 2.2-2.7 2.2-4.6v-3.1c0-2.5 1.9-4.5 4.4-4.5c2.5 0 4.4 2 4.4 4.5v3.1c0 1.9 .9 3.5 2.2 4.6Zm-6.6 5.6c-1.6 0-3.1-0.9-3.8-2.2h7.6c-0.7 1.3-2.2 2.2-3.8 2.2Z" />
        </SvgIcon>
    );
}

export function AlertAltIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M10 20c-5.5 0-10-4.5-10-10c0-5.5 4.5-10 10-10c5.5 0 10 4.5 10 10c0 5.5-4.5 10-10 10Zm0-18c-4.4 0-8 3.6-8 8c0 4.4 3.6 8 8 8c4.4 0 8-3.6 8-8c0-4.4-3.6-8-8-8Zm-1 9v-7h2v7Zm1 4.2c.7 .1 1.2-0.5 1.2-1.2c.1-0.7-0.5-1.2-1.2-1.2c-0.7-0.1-1.2 .5-1.2 1.2c-0.1 .7 .5 1.2 1.2 1.2Z" />
        </SvgIcon>
    );
}

export function AvailableIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M0 10c0 5.5 4.5 10 10 10c5.5 0 10-4.5 10-10c0-5.5-4.5-10-10-10c-5.5 0-10 4.5-10 10Zm2 0c0-4.4 3.6-8 8-8c4.4 0 8 3.6 8 8c0 4.4-3.6 8-8 8c-4.4 0-8-3.6-8-8Zm3.1 .9l4.1 4l5.8-8.2l-2-1.4l-4.2 5.8l-1.9-2Z" />
        </SvgIcon>
    );
}

export function CancelReservationIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M1.7 15.2h10.1v1.7h-10.1c-0.9 0-1.7-0.8-1.7-1.7v-11c0-0.9 .8-1.7 1.7-1.7h1.7v1.7h.8v-4.2h1.7v2.5h5.9v1.7h.9v-4.2h1.6v2.5h.9c.9 0 1.7 .8 1.7 1.7v7.6h-1.7v-5.1h-13.5Zm17.1-1.5l1.2 1.2l-1.9 2l1.9 1.9l-1.2 1.2l-1.9-1.9l-2 1.9l-1.2-1.2l2-1.9l-2-2l1.2-1.2l2 2Z" />
        </SvgIcon>
    );
}

export function CancelSessionIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M10 3.9l-0.8 1l-1.5-1.4l2.5-3.1c.3-0.4 .7-0.5 1.1-0.3c.4 .1 .7 .5 .7 .9v6.8l-2-2Zm-7.3-2.6l-1.4 1.4l3.9 3.9l-3 3.8c-0.2 .3-0.3 .7-0.1 1c.2 .4 .5 .6 .9 .6h5v7c0 .4 .3 .8 .7 .9c.1 .1 .2 .1 .3 .1c.3 0 .6-0.1 .8-0.4l3.7-4.6l3.8 3.7l1.4-1.4Zm11.5 8.7h.7l-0.3 .4l1.4 1.4l1.8-2.2c.2-0.3 .3-0.7 .1-1c-0.1-0.4-0.5-0.6-0.9-0.6h-4.8Zm-9.1 0l1.5-1.9l2 1.9Zm4.9 6.1v-4.7l2.1 2.1Z" />
        </SvgIcon>
    );
}

export function CheckIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M7.6 16.8c-0.3 0-0.6-0.2-0.8-0.4l-5.5-5.8c-0.4-0.4-0.4-1.1 .1-1.6c.4-0.4 1.2-0.4 1.6 .1l4.6 4.9l9.4-10.3c.3-0.3 .7-0.5 1.1-0.4c.4 .1 .8 .4 .9 .8c.1 .4 0 .8-0.3 1.1l-10.3 11.2c-0.2 .2-0.5 .4-0.8 .4Z" />
        </SvgIcon>
    );
}

export function CheckInIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M2.1 7.9c0-4.4 3.5-7.9 7.9-7.9c4.3 0 7.8 3.5 7.8 7.9c0 4.3-4.5 9.3-7.8 12.1c-3.3-2.8-7.9-7.8-7.9-12.1Zm2 0c0 3.3 3.8 7.5 5.9 9.5c2.1-2 5.9-6.2 5.9-9.5c0-3.3-2.7-5.9-5.9-5.9c-3.3 0-5.9 2.6-5.9 5.9Zm4.9 1.5l4.2-4.2l1.4 1.4l-4.9 4.9c-0.2 .2-0.5 .3-0.7 .3c-0.3 0-0.5-0.1-0.7-0.3l-3-2.9l1.4-1.4Z" />
        </SvgIcon>
    );
}

export function CompanyIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M3 19c0 .5 .4 1 1 1h12c.6 0 1-0.5 1-1v-7h1c.8 0 1.5-0.5 1.8-1.3c.4-0.7 .2-1.6-0.4-2.1l-8-8c-0.4-0.4-0.9-0.6-1.4-0.6c-0.5 0-1 .2-1.4 .6l-8 8c-0.6 .5-0.8 1.4-0.4 2.1c.3 .8 1 1.3 1.8 1.3h1Zm12-1h-10v-7c0-0.6-0.4-1-1-1h-2l8-8l8 8h-2c-0.6 0-1 .4-1 1Zm-3-7c0 1.1-0.9 2-2 2c-1.1 0-2-0.9-2-2c0-1.1 .9-2 2-2c1.1 0 2 .9 2 2Zm-5 6c0-1.9 1.2-3 3-3c1.8 0 3 1.1 3 3Z" />
        </SvgIcon>
    );
}

export function CopyIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M7.3 0h6.7l4.2 4.2v10.3c0 1-0.9 1.9-1.9 1.9h-9c-1 0-1.9-0.9-1.9-1.9v-12.7c0-1 .9-1.8 1.9-1.8Zm0 14.5h9v-9h-3.6v-3.7h-5.4Zm-5.5-10.9h1.8v14.6h10.9v1.8h-10.9c-1 0-1.8-0.8-1.8-1.8Z" />
        </SvgIcon>
    );
}

export function CopyAltIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M5 0h14c.6 0 1 .4 1 1v14c0 .6-0.4 1-1 1h-14c-0.6 0-1-0.4-1-1v-14c0-0.6 .4-1 1-1Zm1 14h12v-12h-12Zm-6-10h2v14h14v2h-15c-0.6 0-1-0.4-1-1Z" />
        </SvgIcon>
    );
}

export function CopyPlusIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M19 0h-14c-0.6 0-1 .4-1 1v14c0 .6 .4 1 1 1h14c.6 0 1-0.4 1-1v-14c0-0.6-0.4-1-1-1Zm-1 14h-12v-12h12Zm-16-10h-2v15c0 .6 .4 1 1 1h15v-2h-14Zm11 8h-2v-3h-3v-2h3v-3h2v3h3v2h-3Z" />
        </SvgIcon>
    );
}

export function CupIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M18 5c0 .3-0.1 .6-0.4 .8l-1.6 1.3c0 0 0-0.1 0-0.1v-4h2v2Zm-8 6c-2.2 0-4-1.8-4-4v-5h8v5c0 2.2-1.8 4-4 4Zm-7.6-5.2c-0.3-0.2-0.4-0.5-0.4-0.8v-2h2v4c0 0 0 .1 0 .1l-1.6-1.3Zm9.6 12.2h-4v-1h4v1Zm7-17h-3.3c-0.3-0.6-1-1-1.7-1h-8c-0.7 0-1.4 .4-1.7 1h-3.3c-0.6 0-1 .4-1 1v3c0 1 .4 1.8 1.1 2.4l4.2 3.3c.9 1.2 2.2 2 3.7 2.2v2.1h-2c-0.6 0-1 .4-1 1v2h-1v2h2h6h2v-2h-1v-2c0-0.6-0.4-1-1-1h-2v-2.1c1.5-0.2 2.8-1 3.7-2.2l4.2-3.3c.7-0.6 1.1-1.4 1.1-2.4v-3c0-0.6-0.4-1-1-1Z" />
        </SvgIcon>
    );
}

export function CustomerGroupsIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M10.3 2.2l8.7 7.4l1.1-1.5l-9.8-8.4l-9.9 8.4l1.2 1.5Zm-4.2 10.1c0-0.8-0.6-1.5-1.4-1.5c-0.8 0-1.4 .7-1.4 1.5c0 .8 .6 1.5 1.4 1.5c.8 0 1.4-0.7 1.4-1.5Zm5.6 0c0-0.8-0.7-1.5-1.4-1.5c-0.8 0-1.4 .7-1.4 1.5c0 .8 .6 1.5 1.4 1.5c.7 0 1.4-0.7 1.4-1.5Zm4.1-1.5c.8 0 1.4 .7 1.4 1.5c0 .8-0.6 1.5-1.4 1.5c-0.7 0-1.4-0.7-1.4-1.5c0-0.8 .7-1.5 1.4-1.5Zm-13 8.9v-3c0-1 .9-1.9 1.9-1.9c1 0 1.8 .9 1.8 1.9v3Zm5.6 0v-3c0-1 .8-1.9 1.9-1.9c1 0 1.8 .9 1.8 1.9v3Zm9.3 0h-3.7v-3c0-1 .8-1.9 1.8-1.9c1.1 0 1.9 .9 1.9 1.9Z" />
        </SvgIcon>
    );
}

export function CustomersIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M2 6h-2v-4c0-1.1 .9-2 2-2h4v2h-4Zm16 0h2v-4c0-1.1-0.9-2-2-2h-4v2h4Zm-8 4c1.4 0 2.5-1.1 2.5-2.5c0-1.4-1.1-2.5-2.5-2.5c-1.4 0-2.5 1.1-2.5 2.5c0 1.4 1.1 2.5 2.5 2.5Zm0 1.2c-2.3 .1-3.8 1.5-3.8 3.8h7.5c.1-2.3-1.4-3.8-3.7-3.8Zm-8 8.8h4v-2h-4v-4h-2v4c0 1.1 .9 2 2 2Zm16 0h-4v-2h4v-4h2v4c0 1.1-0.9 2-2 2Z" />
        </SvgIcon>
    );
}

export function DashboardIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M0 12c0-5.5 4.5-10 10-10c5.5 0 10 4.5 10 10v4.5h-20Zm13.5 2.7h4.7v-2.7c0-4.5-3.7-8.2-8.2-8.2c-4.5 0-8.2 3.7-8.2 8.2v2.7h4.7c.3-1.2 1.3-2.2 2.6-2.6v-3.7h1.8v3.7c1.3 .4 2.3 1.4 2.6 2.6Zm-3.5-8.2c.5 0 .9-0.4 .9-0.9c0-0.5-0.4-0.9-0.9-0.9c-0.5 0-0.9 .4-0.9 .9c0 .5 .4 .9 .9 .9Zm5.1 1.6c-0.3 .4-0.9 .4-1.2 0c-0.4-0.3-0.4-0.9 0-1.2c.3-0.4 .9-0.4 1.2 0c.4 .3 .4 .9 0 1.2Zm-9 0c-0.3 .4-0.9 .4-1.2 0c-0.4-0.3-0.4-0.9 0-1.2c.3-0.4 .9-0.4 1.2 0c.4 .3 .4 .9 0 1.2Zm-2.5 4.8c.5 0 .9-0.4 .9-0.9c0-0.5-0.4-0.9-0.9-0.9c-0.5 0-0.9 .4-0.9 .9c0 .5 .4 .9 .9 .9Zm12.8 0c.5 0 .9-0.4 .9-0.9c0-0.5-0.4-0.9-0.9-0.9c-0.5 0-0.9 .4-0.9 .9c0 .5 .4 .9 .9 .9Zm-6.4 .9c-0.7 0-1.3 .4-1.6 .9h3.2c-0.3-0.5-0.9-0.9-1.6-0.9Z" />
        </SvgIcon>
    );
}

export function DeleteIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M13 1v2h6v2h-18v-2h6v-2Zm-8 19c-1.1 0-2-0.9-2-2v-12h14v12c0 1.1-0.9 2-2 2Zm10-12h-10v10h10Zm-8 8h2v-6h-2Zm6 0h-2v-6h2Z" />
        </SvgIcon>
    );
}

export function DetailsIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M10.3 1.7h-8.6v15.4h6.8v1.7h-6.8c-0.9 0-1.7-0.8-1.7-1.7v-15.4c0-0.9 .8-1.7 1.7-1.7h9.8l3.9 3.9v3.8h-1.7v-2.6h-3.4Zm-6.9 6h6.9v1.7h-6.9Zm14.5 6c0 .8-0.2 1.6-0.7 2.3l2.8 2.8l-1.2 1.2l-2.8-2.8c-0.7 .5-1.5 .7-2.3 .7c-2.4 0-4.3-1.9-4.3-4.2c0-2.4 1.9-4.3 4.3-4.3c2.3 0 4.2 1.9 4.2 4.3Zm-14.5-0.9h4.3v-1.7h-4.3Zm7.7 .9c0 1.4 1.2 2.5 2.6 2.5c1.4 0 2.5-1.1 2.5-2.5c0-1.4-1.1-2.6-2.5-2.6c-1.4 0-2.6 1.2-2.6 2.6Z" />
        </SvgIcon>
    );
}

export function DiagnosticsIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M7.7 15.4h-6v-13.7h6.4l3.9 4.6v1.4h1.7v-1.4c0-0.4-0.2-0.8-0.4-1.1l-3.8-4.6c-0.4-0.4-0.8-0.6-1.4-0.6h-6.4c-0.9 0-1.7 .8-1.7 1.7v13.7c0 .9 .8 1.7 1.7 1.7h6Zm-5.1-9.4h1.7v-2.6h-1.7Zm2.5 0h1.7v-2.6h-1.7Zm12.1 10l2.8 2.8l-1.2 1.2l-2.8-2.8c-0.7 .5-1.5 .7-2.3 .7c-2.4 0-4.3-1.9-4.3-4.2c0-2.4 1.9-4.3 4.3-4.3c2.3 0 4.2 1.9 4.2 4.3c0 .8-0.2 1.6-0.7 2.3Zm-3.5-4.9c-1.4 0-2.6 1.2-2.6 2.6c0 1.4 1.2 2.5 2.6 2.5c1.4 0 2.5-1.1 2.5-2.5c0-1.4-1.1-2.6-2.5-2.6Z" />
        </SvgIcon>
    );
}

export function DownIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M10.4 9.8l-8.4-8.4l1.4-1.4l7 7l7-7l1.4 1.4Zm0 5l-8.4-8.4l1.4-1.4l7 7l7-7l1.4 1.4Zm-8.4-3.4l8.4 8.4l8.4-8.4l-1.4-1.4l-7 7l-7-7Z" />
        </SvgIcon>
    );
}

export function DownloadIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M13.3 5.3l1.4 1.4l-4.7 4.7l-4.7-4.7l1.4-1.4l2.3 2.3v-7.6h2v7.6Zm-1.7 8.7l2-2h6.4v8h-20v-8h6.4l2 2Zm-9.6 0v4h16v-4h-3.6l-2 2h-4.8l-2-2Z" />
        </SvgIcon>
    );
}

export function DuplicateIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M13.6 1.8v10c0 1-0.8 1.8-1.8 1.8h-10c-1 0-1.8-0.8-1.8-1.8v-10c0-1 .8-1.8 1.8-1.8h10c1 0 1.8 .8 1.8 1.8Zm-11.8 0v10h10v-10Zm13.7 7.3h1.8v-1.8h-1.8Zm4.5 0h-1.8v-1.8h1.8Zm-1.8 2.7h1.8v-1.8h-1.8Zm1.8 2.7h-1.8v-1.8h1.8Zm-10.9 2.8h-1.8v-1.8h1.8Zm9.1 0h1.8v-1.8h-1.8Zm-10.9 2.7h1.8v-1.8h-1.8Zm4.5 0h-1.8v-1.8h1.8Zm.9-1.8v1.8h1.8v-1.8Zm4.6 1.8h-1.8v-1.8h1.8Zm2.7 0h-1.8v-1.8h1.8Z" />
        </SvgIcon>
    );
}

export function EditIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M19.4 .6c.8 .8 .8 2 0 2.8l-6.3 6.4l-2.9-2.9l6.4-6.3c.8-0.8 2-0.8 2.8 0Zm-16.4 19.4c-1.1 0-2-0.9-2-2v-14c0-1.1 .9-2 2-2h7v2h-7v14h14v-9h2v9c0 1.1-0.9 2-2 2Zm5.8-11.6l2.8 2.8l-3.5 .7Z" />
        </SvgIcon>
    );
}

export function EnergyIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M10.1 18.8l-4.3-10.9l-1.9 5.1h-3.9v-1.6h2.8l3-8.2l4.1 10.7l2.4-7.2l2.4 4.7h5.3v1.6h-6.3l-1-2Z" />
        </SvgIcon>
    );
}

export function FilterIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M11.3 10.3c-0.2 .2-0.3 .4-0.3 .7v3.6l-2 2v-5.6c0-0.3-0.1-0.5-0.3-0.7l-4.7-4.7v-3.6h12v3.6l-4.7 4.7Zm4.7-10.3h-12c-1.1 0-2 .9-2 2v4c0 .3 .1 .5 .3 .7l4.7 4.7v7.6c0 .4 .2 .8 .6 .9c.1 .1 .3 .1 .4 .1c.3 0 .5-0.1 .7-0.3l4-4c.2-0.2 .3-0.4 .3-0.7v-3.6l4.7-4.7c.2-0.2 .3-0.4 .3-0.7v-4c0-1.1-0.9-2-2-2Z" />
        </SvgIcon>
    );
}

export function FirmwareIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M6.7 15h-1.7v-13.3h8.3v6.6h1.7v-7.5c0-0.4-0.4-0.8-0.8-0.8h-13.4c-0.4 0-0.8 .4-0.8 .8v15c0 .5 .4 .9 .8 .9h5.9Zm-3.4 0h-1.6v-13.3h1.6Zm10.9-3l4.4 4.4l1.2-1.2l-5-5c-0.4-0.3-0.9-0.3-1.2 0l-5 5l1.2 1.2Zm-1.7 6.3v-3.3l-1.7 1.7v2.5c0 .4 .4 .8 .9 .8h5c.4 0 .8-0.4 .8-0.8v-2.5l-1.7-1.7v3.3Z" />
        </SvgIcon>
    );
}

export function HardResetIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M9 9h2v-8h-2Zm4-3.2v-2.2c2.9 1.2 5 4 5 7.4c0 4.4-3.6 8-8 8c-4.4 0-8-3.6-8-8c0-3.4 2.1-6.2 5-7.4v2.2c-1.8 1.1-3 3-3 5.2c0 3.3 2.7 6 6 6c3.3 0 6-2.7 6-6c0-2.2-1.2-4.1-3-5.2Z" />
        </SvgIcon>
    );
}

export function ImageIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M2 2h13.4l4.6 4.6v9.4c0 1.1-0.9 2-2 2h-16c-1.1 0-2-0.9-2-2v-12c0-1.1 .9-2 2-2Zm0 2v12h16v-8h-4v-4Zm4.5 6l1.5 2.5l3.5-5.7l4.5 7.2h-12Z" />
        </SvgIcon>
    );
}

export function InfoAltIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M10 20c-5.5 0-10-4.5-10-10c0-5.5 4.5-10 10-10c5.5 0 10 4.5 10 10c0 5.5-4.5 10-10 10Zm0-18c-4.4 0-8 3.6-8 8c0 4.4 3.6 8 8 8c4.4 0 8-3.6 8-8c0-4.4-3.6-8-8-8Zm0 5.2c.7 0 1.2-0.5 1.2-1.2c.1-0.7-0.5-1.2-1.2-1.2c-0.7 0-1.2 .5-1.2 1.2c-0.1 .7 .5 1.2 1.2 1.2Zm1 5.8v-4c0-0.6-0.4-1-1-1h-2v2h1v3h-2v2h6v-2Z" />
        </SvgIcon>
    );
}

export function InvoicesIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M11.7 15h-10v-13.3h6.2l3.8 4.4v2.2h1.6v-2.2c0-0.4-0.1-0.7-0.4-1l-3.7-4.5c-0.3-0.4-0.8-0.6-1.3-0.6h-6.2c-1 0-1.7 .7-1.7 1.7v13.3c0 .9 .7 1.7 1.7 1.7h10Zm-9.2-9.2h1.7v-2.5h-1.7Zm2.5 0h1.7v-2.5h-1.7Zm10.8 8.4h1.7c1.4 0 2.5 1.1 2.5 2.5c0 1.3-1.1 2.5-2.5 2.5v.8h-1.7v-0.8h-1.6v-1.7h3.3c.5 0 .8-0.4 .8-0.8c0-0.5-0.3-0.9-0.8-0.9h-1.7c-1.3 0-2.5-1.1-2.5-2.5c0-1.3 1.2-2.5 2.5-2.5v-0.8h1.7v.8h1.7v1.7h-3.4c-0.4 0-0.8 .4-0.8 .8c0 .5 .4 .9 .8 .9Z" />
        </SvgIcon>
    );
}

export function InvoicesDownloadIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M10.1 15.2h-8.4v-13.5h6.3l3.8 4.5v3.9h1.7v-3.9c0-0.4-0.1-0.8-0.4-1.1l-3.8-4.5c-0.3-0.4-0.8-0.6-1.3-0.6h-6.3c-0.9 0-1.7 .8-1.7 1.7v13.5c0 .9 .8 1.7 1.7 1.7h8.4Zm-7.6-9.3h1.7v-2.5h-1.7Zm2.6 0h1.6v-2.5h-1.6Zm11.8 10.6l1.9-1.9l1.2 1.2l-4 3.9l-3.9-3.9l1.2-1.2l1.9 1.9v-4.7h1.7Z" />
        </SvgIcon>
    );
}

export function LinkIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M2.3 12.1l.7 .7l-1.4 1.4l-0.7-0.7c-1.2-1.2-1.2-3.1 0-4.2l8.4-8.5c1.1-1.1 3.1-1.1 4.2 0l.7 .7l-1.4 1.5l-0.7-0.8c-0.2-0.1-0.4-0.2-0.7-0.2c-0.3 0-0.5 .1-0.7 .2l-8.4 8.5c-0.4 .4-0.4 1 0 1.4Zm9.8-2.8l-1.4-1.4l7-7.1l1.4 1.4Zm6.3-3.5l.7 .7c.6 .5 .9 1.3 .9 2.1c0 .8-0.3 1.5-0.9 2.1l-8.4 8.4c-0.6 .6-1.3 .9-2.1 .9c-0.8 0-1.5-0.3-2.1-0.9l-0.7-0.7l1.4-1.4l.7 .7c.4 .4 1 .4 1.4 0l8.4-8.4c.2-0.2 .3-0.5 .3-0.7c0-0.3-0.1-0.5-0.3-0.7l-0.7-0.7Zm-17.5 11.9l1.4 1.4l7-7l-1.4-1.4Z" />
        </SvgIcon>
    );
}

export function LocationIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M5 9.6v-7.2l10 3.6l-10 3.6Zm13.3-4.5l-14-5c-0.3-0.2-0.6-0.1-0.9 .1c-0.2 .2-0.4 .5-0.4 .8v19h2v-8.3l13.3-4.8c.4-0.1 .7-0.5 .7-0.9c0-0.4-0.3-0.8-0.7-0.9Z" />
        </SvgIcon>
    );
}

export function LoginIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M5 5c0 2.8 2.2 5 5 5c2.8 0 5-2.2 5-5c0-2.8-2.2-5-5-5c-2.8 0-5 2.2-5 5Zm2.5 0c0-1.4 1.1-2.5 2.5-2.5c1.4 0 2.5 1.1 2.5 2.5c0 1.4-1.1 2.5-2.5 2.5c-1.4 0-2.5-1.1-2.5-2.5Zm-7.5 13.8v1.2h20v-1.2c0-4.5-4.1-7.6-10-7.6c-5.9 0-10 3.1-10 7.5Zm17.3-1.3h-14.6c.7-2.3 3.5-3.8 7.3-3.8c3.8 .1 6.6 1.5 7.3 3.8Z" />
        </SvgIcon>
    );
}

export function LogoutIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M.5 7c1.2-4.1 5-7 9.5-7c5.5 0 10 4.5 10 10c0 5.5-4.5 10-10 10c-4.5 0-8.3-2.9-9.5-7h2.1c1.2 2.9 4 5 7.4 5c4.4 0 8-3.6 8-8c0-4.4-3.6-8-8-8c-3.4 0-6.2 2.1-7.4 5Zm8.8-0.3l1.4-1.4l4.7 4.7l-4.7 4.7l-1.4-1.4l2.3-2.3h-11.6v-2h11.6Z" />
        </SvgIcon>
    );
}

export function MakeReservationIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M1.7 15v-8.3h15v-2.5c0-1-0.8-1.7-1.7-1.7h-0.8v-2.5h-1.7v4.2h-0.8v-1.7h-5.9v-2.5h-1.6v4.2h-0.9v-1.7h-1.6c-1 0-1.7 .7-1.7 1.7v10.8c0 .9 .7 1.7 1.7 1.7h5v-1.7Zm12.5 5c-3.2 0-5.9-2.6-5.9-5.8c0-3.2 2.7-5.9 5.9-5.9c3.2 0 5.8 2.7 5.8 5.9c0 3.2-2.6 5.8-5.8 5.8Zm0-10c-2.3 0-4.2 1.9-4.2 4.2c0 2.3 1.9 4.1 4.2 4.1c2.3 0 4.1-1.8 4.1-4.1c0-2.3-1.8-4.2-4.1-4.2Zm-0.9 .8v4.2h3.4v-1.7h-1.7v-2.5Z" />
        </SvgIcon>
    );
}

export function ManageIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M17.7 8h2.3v4h-2.3c-0.2 .9-0.6 1.7-1.1 2.5l1.5 1.5l-2.1 2.1l-1.5-1.5c-0.8 .5-1.6 .9-2.5 1.1v2.3h-4v-2.3c-0.9-0.2-1.7-0.6-2.5-1.1l-1.5 1.5l-2.1-2.1l1.5-1.5c-0.5-0.8-0.9-1.6-1.1-2.5h-2.3v-4h2.3c.2-0.9 .6-1.7 1.1-2.5l-1.5-1.5l2.1-2.1l1.5 1.5c.8-0.5 1.6-0.9 2.5-1.1v-2.3h4v2.3c.9 .2 1.7 .6 2.5 1.1l1.5-1.5l2.1 2.1l-1.5 1.5c.5 .8 .9 1.6 1.1 2.5Zm-13.7 2c0 3.3 2.7 6 6 6c3.3 0 6-2.7 6-6c0-3.3-2.7-6-6-6c-3.3 0-6 2.7-6 6Zm9 0l-5-3v6Z" />
        </SvgIcon>
    );
}

export function MergeIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M5.5 4.8h-5.5v1.8h5.5c2.4 0 2.9 .7 3.6 1.6c.4 .6 .8 1.3 1.7 1.8c-0.9 .5-1.3 1.2-1.7 1.8c-0.7 .9-1.2 1.6-3.6 1.6h-5.5v1.8h5.5c3.3 0 4.2-1.3 5-2.4c.7-1.1 1.3-1.9 4.4-1.9h1.8l-1.1 1.1l1.2 1.2l3.2-3.2l-3.2-3.2l-1.2 1.2l1.1 1.1h-1.8c-3.1 0-3.7-0.8-4.4-1.9c-0.8-1.1-1.7-2.4-5-2.4Z" />
        </SvgIcon>
    );
}

export function MinusIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M18 10.9h-16v-1.8h16Z" />
        </SvgIcon>
    );
}

export function MoreVerticalIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M10 5.6c-1 0-1.8-0.8-1.8-1.8c0-1 .8-1.8 1.8-1.8c1 0 1.8 .8 1.8 1.8c0 1-0.8 1.8-1.8 1.8Zm0 6.2c-1 0-1.8-0.8-1.8-1.8c0-1 .8-1.8 1.8-1.8c1 0 1.8 .8 1.8 1.8c0 1-0.8 1.8-1.8 1.8Zm-1.8 4.4c0 1 .8 1.8 1.8 1.8c1 0 1.8-0.8 1.8-1.8c0-1-0.8-1.8-1.8-1.8c-1 0-1.8 .8-1.8 1.8Z" />
        </SvgIcon>
    );
}

export function PayNowIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M3.3 13.7h-1.6v-5h1.6v5Zm15-11.7h-10c-0.9 0-1.6 .7-1.6 1.7v.8h1.6v-0.8h10v1.6h-5.8v1.7h5.8v5h-10v-0.8h-1.6v.8c0 .9 .7 1.7 1.6 1.7h5.4l-0.7 1.2c-0.1 .3-0.4 .4-0.7 .4h-5.3l-2-2v-4.3l2-2h3v.8c0 .5-0.4 .9-0.8 .9h-1.7v1.6h1.7c1.3 0 2.5-1.1 2.5-2.5v-1.6c0-0.5-0.4-0.9-0.9-0.9h-4.1c-0.3 0-0.5 .1-0.6 .3l-1.6 1.5c-0.1-0.1-0.2-0.1-0.3-0.1h-3.4c-0.4 0-0.8 .4-0.8 .8v6.7c0 .5 .4 .8 .8 .8h3.4c.1 0 .2 0 .3-0.1l1.6 1.6c.1 .1 .3 .2 .6 .2h5.6c1 0 1.8-0.5 2.2-1.4l1-1.9h2.8c1 0 1.7-0.8 1.7-1.7v-8.3c0-1-0.7-1.7-1.7-1.7Z" />
        </SvgIcon>
    );
}

export function PlusIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M18 9.1h-7.1v-7.1h-1.8v7.1h-7.1v1.8h7.1v7.1h1.8v-7.1h7.1Z" />
        </SvgIcon>
    );
}

export function QRCodeIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M7.5 7.5h-7.5v-7.5h7.5Zm5-7.5h-2.5v2.5h2.5Zm0 7.5h7.5v-7.5h-7.5Zm-11.1-1.4h4.7v-4.7h-4.7Zm17.2 0h-4.7v-4.7h4.7Zm-16.1-3.6h2.5v2.5h-2.5Zm12.5 0h2.5v2.5h-2.5Zm-7.5 2.5h2.5v2.5h-2.5Zm5 5h-2.5v-2.5h2.5Zm2.5 0h-2.5v2.5h-2.5v2.5h5v5h5v-2.5h-2.5v-2.5h2.5v-5h-2.5v-2.5h-2.5Zm2.5 2.5h-2.5v-2.5h2.5Zm-15-2.5v-2.5h-2.5v2.5Zm2.5 0h2.5v2.5h-2.5Zm-5 10h7.5v-7.5h-7.5Zm6.1-1.4h-4.7v-4.7h4.7Zm-3.6-3.6h2.5v2.5h-2.5Zm10 2.5h-2.5v2.5h2.5Z" />
        </SvgIcon>
    );
}

export function RfidDeleteIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M16.9 6.7v-5.9c0-0.4-0.4-0.8-0.9-0.8h-5.9c-0.2 0-0.4 .1-0.6 .2l-9.3 9.3c-0.3 .4-0.3 .9 0 1.2l6 5.9c.1 .2 .3 .3 .5 .3c.3 0 .5-0.1 .6-0.3l9.3-9.3c.2-0.1 .3-0.3 .3-0.6Zm-1.7-0.3l-8.5 8.4l-4.7-4.7l8.5-8.4h4.7Zm-2.5-0.5c.9 0 1.6-0.8 1.6-1.7c0-0.9-0.7-1.7-1.6-1.7c-1 0-1.7 .8-1.7 1.7c0 .9 .7 1.7 1.7 1.7Zm6.1 7.8l1.2 1.2l-1.9 2l1.9 1.9l-1.2 1.2l-1.9-1.9l-2 1.9l-1.2-1.2l2-1.9l-2-2l1.2-1.2l2 2Z" />
        </SvgIcon>
    );
}

export function RfidUploadIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M16.7 6.7v-5.9c0-0.4-0.4-0.8-0.9-0.8h-5.8c-0.2 0-0.4 .1-0.6 .2l-9.2 9.2c-0.3 .3-0.3 .9 0 1.2l5.9 5.8c.1 .2 .4 .3 .6 .3c.2 0 .4-0.1 .6-0.3l9.1-9.1c.2-0.2 .3-0.4 .3-0.6Zm-1.7-0.4l-8.3 8.4l-4.7-4.7l8.3-8.3h4.7Zm-2.5-0.5c.9 0 1.7-0.7 1.7-1.6c0-1-0.8-1.7-1.7-1.7c-0.9 0-1.7 .7-1.7 1.7c0 .9 .8 1.6 1.7 1.6Zm3.3 6.4l4 3.9l-1.2 1.2l-1.9-2v4.7h-1.7v-4.7l-1.9 2l-1.2-1.2Z" />
        </SvgIcon>
    );
}

export function SearchIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M8 14c-1.6 0-3.1-0.6-4.2-1.8c-1.2-1.1-1.8-2.6-1.8-4.2c0-1.6 .6-3.1 1.8-4.2c1.1-1.2 2.6-1.8 4.2-1.8c1.6 0 3.1 .6 4.2 1.8c1.2 1.1 1.8 2.6 1.8 4.2c0 1.6-0.6 3.1-1.8 4.2c-1.1 1.2-2.6 1.8-4.2 1.8Zm11.7 4.3l-5.4-5.4c1.1-1.4 1.7-3.1 1.7-4.9c0-2.1-0.8-4.1-2.3-5.7c-1.6-1.5-3.6-2.3-5.7-2.3c-2.1 0-4.1 .8-5.7 2.3c-1.5 1.6-2.3 3.6-2.3 5.7c0 2.1 .8 4.1 2.3 5.7c1.6 1.5 3.6 2.3 5.7 2.3c1.8 0 3.5-0.6 4.9-1.7l5.4 5.4l1.4-1.4Z" />
        </SvgIcon>
    );
}

export function SessionsIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M5.1 10h3.9c.6 0 1 .4 1 1v5.2l4.9-6.2h-3.9c-0.6 0-1-0.4-1-1v-5.1l-4.9 6.1Zm3.9 10c-0.1 0-0.2 0-0.3-0.1c-0.4-0.1-0.7-0.5-0.7-0.9v-7h-5c-0.4 0-0.7-0.2-0.9-0.6c-0.2-0.3-0.1-0.7 .1-1l8-10c.3-0.4 .7-0.5 1.1-0.3c.4 .1 .7 .5 .7 .9v7h5c.4 0 .7 .2 .9 .6c.2 .3 .1 .7-0.1 1l-8 10c-0.2 .3-0.5 .4-0.8 .4Z" />
        </SvgIcon>
    );
}

export function SettingsIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M10 12c-2.8 0-5-2.3-5-5c0-1.6 .8-3.1 2-4v3c0 1.6 1.3 3 3 3c1.7 0 3-1.4 3-3v-3c1.2 .9 2 2.4 2 4c0 2.7-2.2 5-5 5m7-5c0-3-1.9-5.6-4.7-6.6l-1.3-0.5v6.1c0 .5-0.4 1-1 1c-0.6 0-1-0.5-1-1v-6.1l-1.3 .5c-2.8 1-4.7 3.6-4.7 6.6c0 2.8 1.6 5.1 4 6.3v6.6h2v-5.9h2v5.9h2v-6.6c2.4-1.2 4-3.5 4-6.3" />
        </SvgIcon>
    );
}

export function ShortcutIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M2 16h9v-3h2v5h-13v-16h13v2h-11Zm11.6-11l1.4-1.4l4.4 4.4l-4.4 4.4l-1.4-1.4l2-2h-5.6c-1.1 0-2 .9-2 2v1h-2v-1c0-2.2 1.8-4 4-4h5.6Z" />
        </SvgIcon>
    );
}

export function SoftResetIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M6 .8l.6 1.7l.8-0.2c.6-0.2 1.1-0.3 1.7-0.4l.9-0.1l-0.2-1.8l-0.9 .1c-0.7 .1-1.4 .2-2 .4Zm8 2.1l.8 .5l.9-1.6l-0.8-0.4c-0.6-0.4-1.2-0.7-1.9-0.9l-0.9-0.3l-0.5 1.8l.9 .2c.5 .2 1 .4 1.5 .7Zm-12.6 2l1.4 1.1l.6-0.8c.3-0.4 .7-0.9 1.1-1.2l.7-0.7l-1.3-1.3l-0.6 .6c-0.5 .5-1 1-1.4 1.6Zm16 1.8l.4 .8l1.6-0.8l-0.4-0.8c-0.2-0.6-0.6-1.2-1-1.8l-0.5-0.7l-1.5 1.1l.5 .7c.4 .4 .7 .9 .9 1.5Zm-11.1 3.3c0 2 1.7 3.6 3.7 3.6c2 0 3.6-1.6 3.6-3.6c0-2-1.6-3.6-3.6-3.6c-2 0-3.7 1.6-3.7 3.6Zm-6.3 0v.9h1.8v-0.9c0-0.6 .1-1.1 .2-1.7l.2-0.9l-1.8-0.3l-0.2 .9c-0.1 .6-0.2 1.3-0.2 2Zm8.1 0c0-1 .9-1.8 1.9-1.8c1 0 1.8 .8 1.8 1.8c0 1-0.8 1.8-1.8 1.8c-1 0-1.9-0.8-1.9-1.8Zm9.6 2.6l1.8 .4l.2-0.9c.1-0.7 .2-1.4 .2-2.1v-0.9h-1.8v.9c0 .6-0.1 1.1-0.2 1.7Zm-15.8 3.3l.5 .7l1.5-1.1l-0.5-0.7c-0.4-0.5-0.7-1-0.9-1.5l-0.4-0.8l-1.6 .7l.4 .9c.2 .6 .6 1.2 1 1.8Zm12.8 .8l1.3 1.3l.6-0.6c.5-0.5 1-1 1.4-1.5l.6-0.8l-1.5-1l-0.5 .7c-0.4 .4-0.8 .9-1.2 1.3Zm-7.8 2.8l.9 .3l.5-1.8l-0.8-0.2c-0.6-0.2-1.1-0.5-1.6-0.7l-0.8-0.5l-0.9 1.6l.8 .4c.6 .4 1.2 .7 1.9 .9Zm3-1.3l.2 1.8l.9-0.1c.7-0.1 1.4-0.2 2-0.4l.9-0.3l-0.6-1.7l-0.8 .2c-0.6 .2-1.1 .3-1.7 .4Z" />
        </SvgIcon>
    );
}

export function StartSessionIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M5.1 10h3.9c.6 0 1 .4 1 1v5.2l4.9-6.2h-3.9c-0.6 0-1-0.4-1-1v-5.1l-4.9 6.1Zm3.9 10c-0.1 0-0.2 0-0.3-0.1c-0.4-0.1-0.7-0.5-0.7-0.9v-7h-5c-0.4 0-0.7-0.2-0.9-0.6c-0.2-0.3-0.1-0.7 .1-1l8-10c.3-0.4 .7-0.5 1.1-0.3c.4 .1 .7 .5 .7 .9v7h5c.4 0 .7 .2 .9 .6c.2 .3 .1 .7-0.1 1l-8 10c-0.2 .3-0.5 .4-0.8 .4Z" />
        </SvgIcon>
    );
}

export function StationsAltIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M3 0h14c.6 0 1 .4 1 1v18c0 .6-0.4 1-1 1h-14c-0.6 0-1-0.4-1-1v-18c0-0.6 .4-1 1-1Zm3 2h-2v16h2Zm2 16h8v-16h-8Zm1-14h6v3h-6Z" />
        </SvgIcon>
    );
}

export function SubmissionsIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M13.5 5.1v7.6h1.7v-8.8l-3.9-3.9h-9.6c-0.9 0-1.7 .8-1.7 1.7v15.2c0 .9 .8 1.7 1.7 1.7h9.3v-1.7h-9.3v-15.2h8.4v3.4Zm-3.4 4.2h-6.7v-1.7h6.7Zm-1.7 3.4h-5v-1.7h5Zm6.8 4.7l3.6-3.7l1.2 1.2l-4.8 4.9l-3.1-3.2l1.2-1.2Z" />
        </SvgIcon>
    );
}

export function TariffsIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M10 11.5c-0.1 0-0.3 0-0.4-0.1l-9-4c-0.4-0.1-0.6-0.5-0.6-0.9c0-0.4 .2-0.8 .6-0.9l9-4c.3-0.1 .5-0.1 .8 0l9 4c.4 .1 .6 .5 .6 .9c0 .4-0.2 .8-0.6 .9l-9 4c-0.1 .1-0.3 .1-0.4 .1Zm-6.5-5l6.5 2.9l6.5-2.9l-6.5-2.9Zm16.5 2.4l-10 4.5l-10-4.1v2.1l9.6 4c.1 .1 .3 .1 .4 .1c.1 0 .3 0 .4-0.1l9.6-4.3Zm-10 8.5l10-4.5v2.2l-9.6 4.3c-0.1 .1-0.3 .1-0.4 .1c-0.1 0-0.3 0-0.4-0.1l-9.6-4v-2.1Z" />
        </SvgIcon>
    );
}

export function TimesIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M18 3.3l-1.3-1.3l-6.7 6.7l-6.7-6.7l-1.3 1.3l6.7 6.7l-6.7 6.7l1.3 1.3l6.7-6.7l6.7 6.7l1.3-1.3l-6.7-6.7Z" />
        </SvgIcon>
    );
}

export function TriggerMessageIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M7.3 3.4v8.4h10.5v1.7h-10.5c-1 0-1.8-0.8-1.8-1.7v-8.4l-2 2l-1.2-1.3l4.1-4.1l4.1 4.1l-1.2 1.3Zm-2.7 4.8h-2.6v-1.7h2.6Zm7.9 2.7h1.8v-2.7c0-0.9-0.8-1.7-1.8-1.7h-4.4v1.7h4.4Zm1.8 5.7l2-2l1.2 1.3l-4.1 4.1l-4.1-4.1l1.2-1.3l2 2v-2.2h1.8Z" />
        </SvgIcon>
    );
}

export function UnavailableIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M0 10c0 5.5 4.5 10 10 10c5.5 0 10-4.5 10-10c0-5.5-4.5-10-10-10c-5.5 0-10 4.5-10 10Zm2 0c0-4.4 3.6-8 8-8c4.4 0 8 3.6 8 8c0 4.4-3.6 8-8 8c-4.4 0-8-3.6-8-8Zm11.3-4.7l1.4 1.4l-3.3 3.3l3.3 3.3l-1.4 1.4l-3.3-3.3l-3.3 3.3l-1.4-1.4l3.3-3.3l-3.3-3.3l1.4-1.4l3.3 3.3Z" />
        </SvgIcon>
    );
}

export function UnlockIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M7 8h8c1.1 0 2 .9 2 2v7c0 1.1-0.9 2-2 2h-10c-1.1 0-2-0.9-2-2v-7c0-1.1 .9-2 2-2v-3c0-2.8 2.2-5 5-5c2.8 0 5 2.2 5 5v1h-2v-1c0-1.7-1.3-3-3-3c-1.7 0-3 1.3-3 3Zm-2 2v7h10v-7Zm5 5c.8 0 1.5-0.7 1.5-1.5c0-0.8-0.7-1.5-1.5-1.5c-0.8 0-1.5 .7-1.5 1.5c0 .8 .7 1.5 1.5 1.5Z" />
        </SvgIcon>
    );
}

export function UnpaidBalanceIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M18 0h-16c-1.1 0-2 .9-2 1.9v15.2c0 1.1 .9 1.9 2 1.9v1h2v-1h12v1h2v-1c1.1 0 2-0.8 2-1.9v-15.2c0-1-0.9-1.9-2-1.9Zm0 17.1h-16v-15.2h16Zm-14-1.9c0 .6 .4 1 1 1h11c.6 0 1-0.4 1-1v-11.4c0-0.5-0.4-0.9-1-0.9h-11c-0.6 0-1 .4-1 .9v1.9h-1v1.9h1v3.8h-1v1.9h1Zm2-7.6h1v-1.9h-1v-0.9h9v9.5h-9v-1h1v-1.9h-1Zm8 1.9c0 1.6-1.3 2.9-3 2.9c-1.7 0-3-1.3-3-2.9c0-1.6 1.3-2.8 3-2.8c1.7 0 3 1.2 3 2.8Zm-2 0c0-0.5-0.4-0.9-1-0.9c-0.6 0-1 .4-1 .9c0 .5 .4 1 1 1c.6 0 1-0.5 1-1Z" />
        </SvgIcon>
    );
}

export function UpIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M10.4 2.8l7 7l1.4-1.4l-8.4-8.4l-8.4 8.4l1.4 1.4Zm7 12l-7-7l-7 7l-1.4-1.4l8.4-8.4l8.4 8.4Zm0 5l-7-7l-7 7l-1.4-1.4l8.4-8.4l8.4 8.4Z" />
        </SvgIcon>
    );
}

export function UsersIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M7 8.4h8c1.1 0 2 1 2 2.1v7.4c0 1.2-0.9 2.1-2 2.1h-10c-1.1 0-2-0.9-2-2.1v-7.4c0-1.1 .9-2.1 2-2.1v-3.1c0-2.9 2.2-5.3 5-5.3c2.8 0 5 2.4 5 5.3v1h-2v-1c0-1.8-1.3-3.2-3-3.2c-1.7 0-3 1.4-3 3.2Zm-2 2.1v7.4h10v-7.4Zm5 5.3c.8 0 1.5-0.7 1.5-1.6c0-0.9-0.7-1.6-1.5-1.6c-0.8 0-1.5 .7-1.5 1.6c0 .9 .7 1.6 1.5 1.6Z" />
        </SvgIcon>
    );
}

export function ReplaceIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M13.3 5.3l1.4 1.4l-4.7 4.7l-4.7-4.7l1.4-1.4l2.3 2.3v-7.6h2v7.6Zm-1.7 8.7l2-2h6.4v8h-20v-8h6.4l2 2Zm-9.6 0v4h16v-4h-3.6l-2 2h-4.8l-2-2Z" />
        </SvgIcon>
    );
}

export function ListArrowIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M14.5 10l-9-4l2 4l-2 4Z" />
        </SvgIcon>
    );
}

export function CloseCircleOutlineIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M0 10c0 5.5 4.5 10 10 10c5.5 0 10-4.5 10-10c0-5.5-4.5-10-10-10c-5.5 0-10 4.5-10 10Zm2 0c0-4.4 3.6-8 8-8c4.4 0 8 3.6 8 8c0 4.4-3.6 8-8 8c-4.4 0-8-3.6-8-8Zm11.3-4.7l1.4 1.4l-3.3 3.3l3.3 3.3l-1.4 1.4l-3.3-3.3l-3.3 3.3l-1.4-1.4l3.3-3.3l-3.3-3.3l1.4-1.4l3.3 3.3Z" />
        </SvgIcon>
    );
}

export function CheckCircleOutlineIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M0 10c0 5.5 4.5 10 10 10c5.5 0 10-4.5 10-10c0-5.5-4.5-10-10-10c-5.5 0-10 4.5-10 10Zm2 0c0-4.4 3.6-8 8-8c4.4 0 8 3.6 8 8c0 4.4-3.6 8-8 8c-4.4 0-8-3.6-8-8Zm3.1 .9l4.1 4l5.8-8.2l-2-1.4l-4.2 5.8l-1.9-2Z" />
        </SvgIcon>
    );
}

export function CautionIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M19 20h-18c-0.3 0-0.7-0.2-0.9-0.5c-0.1-0.3-0.1-0.6 0-1l9-18c.3-0.7 1.5-0.7 1.8 0l9 18c.1 .4 .1 .7 0 1c-0.2 .3-0.6 .5-0.9 .5Zm-16.4-2h14.8l-7.4-14.8Zm8.4-4h-2v-6h2Zm-1 3.2c.7 0 1.2-0.5 1.2-1.2c0-0.7-0.5-1.3-1.2-1.3c-0.7 0-1.3 .6-1.3 1.3c0 .7 .6 1.2 1.3 1.2Z" />
        </SvgIcon>
    );
}

export function StatusAvailableIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M4.2 11.8h6.8c3.2 0 5.9-2.6 5.9-5.9c0-3.3-2.7-5.9-5.9-5.9c-2.4 0-4.6 1.4-5.5 3.6c-0.4-0.2-0.8-0.2-1.3-0.2c-2.3 0-4.2 1.9-4.2 4.2c0 2.3 1.9 4.2 4.2 4.2Zm-2.5-4.2c0-1.4 1.1-2.5 2.5-2.5c.5 0 1 .1 1.4 .4c.2 .1 .5 .1 .8 0c.2-0.1 .4-0.3 .5-0.6c.4-1.9 2.1-3.2 4.1-3.2c2.3 0 4.2 1.9 4.2 4.2c0 2.3-1.9 4.2-4.2 4.2h-6.8c-1.4 0-2.5-1.1-2.5-2.5Zm10.4 9l3.1 3.1l4.8-4.8l-1.2-1.2l-3.6 3.7l-1.9-2Z" />
        </SvgIcon>
    );
}

export function StatusChargingIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M4.2 10h4.1v1.7h-4.1c-2.3 0-4.2-1.9-4.2-4.2c0-2.3 1.9-4.2 4.2-4.2c.4 0 .9 .1 1.3 .2c.9-2.1 3-3.5 5.4-3.5c3.2 0 5.8 2.6 5.8 5.8c0 .9-0.2 1.8-0.6 2.5h-1.9c.5-0.7 .8-1.5 .8-2.5c0-2.3-1.8-4.1-4.1-4.1c-2 0-3.7 1.3-4.1 3.2c-0.1 .3-0.3 .5-0.5 .6c-0.3 .1-0.5 .1-0.8-0.1c-0.4-0.3-0.8-0.4-1.3-0.4c-1.4 0-2.5 1.1-2.5 2.5c0 1.4 1.1 2.5 2.5 2.5Zm8.7 3.4l2.2 5.5l1.3-3.9l.5 .7h3.1v-1.2h-2.7l-1.2-2.5l-1.1 3.7l-1-2.7l-1.1-2.8l-1.6 4.3h-1.3v1.2h2.2Z" />
        </SvgIcon>
    );
}

export function StatusIssueDetectedIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M11.3 12.2h-7c-2.3 0-4.3-2-4.3-4.4c0-2.4 2-4.3 4.3-4.3c.5 0 1 .1 1.4 .2c.9-2.2 3.1-3.7 5.6-3.7c3.4 0 6.1 2.7 6.1 6.1c0 3.3-2.7 6.1-6.1 6.1Zm-7-7c-1.4 0-2.6 1.2-2.6 2.6c0 1.5 1.2 2.6 2.6 2.6h7c2.4 0 4.4-1.9 4.4-4.3c0-2.4-2-4.4-4.4-4.4c-2 0-3.8 1.4-4.2 3.4c-0.1 .3-0.3 .5-0.5 .6c-0.3 .1-0.6 .1-0.8-0.1c-0.5-0.2-1-0.4-1.5-0.4Zm15.7 12.2h-1.7v-5.2h1.7Zm-0.9 2.6c.5 0 .9-0.4 .9-0.9c0-0.4-0.4-0.8-0.9-0.8c-0.5 0-0.8 .4-0.8 .8c0 .5 .3 .9 .8 .9Z" />
        </SvgIcon>
    );
}

export function StatusSuspendedReservedIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M6.7 10h-2.5c-1.4 0-2.5-1.1-2.5-2.5c0-1.4 1.1-2.5 2.5-2.5c.4 0 .9 .1 1.3 .4c.2 .1 .5 .2 .8 .1c.2-0.1 .4-0.3 .5-0.6c.4-1.9 2.1-3.2 4-3.2c2.3 0 4.2 1.8 4.2 4.1c0 .3 0 .6-0.1 .9h1.7c0-0.3 .1-0.6 .1-0.9c0-3.2-2.7-5.8-5.9-5.8c-2.3 0-4.4 1.4-5.3 3.5c-0.4-0.1-0.9-0.2-1.3-0.2c-2.3 0-4.2 1.9-4.2 4.2c0 2.3 1.9 4.2 4.2 4.2h2.5Zm7.5 10c-3.2 0-5.9-2.6-5.9-5.8c0-3.2 2.7-5.9 5.9-5.9c3.2 0 5.8 2.7 5.8 5.9c0 3.2-2.6 5.8-5.8 5.8Zm0-10c-2.3 0-4.2 1.9-4.2 4.2c0 2.3 1.9 4.1 4.2 4.1c2.3 0 4.1-1.8 4.1-4.1c0-2.3-1.8-4.2-4.1-4.2Zm-0.9 .8v4.2h3.4v-1.7h-1.7v-2.5Z" />
        </SvgIcon>
    );
}

export function StatusUnavailableIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M4.2 11.8h6.8c3.2 0 5.9-2.6 5.9-5.9c0-3.3-2.7-5.9-5.9-5.9c-2.4 0-4.6 1.4-5.5 3.6c-0.4-0.2-0.8-0.2-1.3-0.2c-2.3 0-4.2 1.9-4.2 4.2c0 2.3 1.9 4.2 4.2 4.2Zm-2.5-4.2c0-1.4 1.1-2.5 2.5-2.5c.5 0 1 .1 1.4 .4c.2 .1 .5 .1 .8 0c.2-0.1 .4-0.3 .5-0.6c.4-1.9 2.1-3.2 4.1-3.2c2.3 0 4.2 1.9 4.2 4.2c0 2.3-1.9 4.2-4.2 4.2h-6.8c-1.4 0-2.5-1.1-2.5-2.5Zm17.1 6.1l1.2 1.2l-1.9 2l1.9 1.9l-1.2 1.2l-1.9-1.9l-2 1.9l-1.2-1.2l2-1.9l-2-2l1.2-1.2l2 2Z" />
        </SvgIcon>
    );
}

export function StatusFinishingIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M11.1 0c3.3 0 6 2.7 6 6c0 3.3-2.7 6-6 6h-6.8c-2.4 0-4.3-2-4.3-4.3c0-2.4 1.9-4.3 4.3-4.3c.4 0 .9 .1 1.3 .2c.9-2.1 3.1-3.6 5.5-3.6Zm-6.8 10.3h6.8c2.4 0 4.3-2 4.3-4.3c0-2.4-1.9-4.3-4.3-4.3c-2 0-3.7 1.4-4.2 3.3c0 .3-0.2 .5-0.5 .6c-0.2 .1-0.5 .1-0.7-0.1c-0.5-0.2-0.9-0.4-1.4-0.4c-1.4 0-2.6 1.2-2.6 2.6c0 1.4 1.2 2.6 2.6 2.6Zm12.4 6.4l2-1.9l1.2 1.2l-4 4l-4-4l1.2-1.2l1.9 1.9v-4.7h1.7Z" />
        </SvgIcon>
    );
}

export function StatusLostConnectionIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M1.2 18.1l17.4-17.5l1.4 1.4l-2.5 2.5c1.2 1.2 1.9 2.8 1.9 4.6c0 3.8-3 6.8-6.8 6.8h-6.5l-3.6 3.5Zm1.9-4.7l-1.4 1.3c-1-0.8-1.7-2.1-1.7-3.6c0-2.7 2.2-4.9 4.8-4.9c.6 0 1.1 .1 1.6 .3c1-2.5 3.4-4.2 6.2-4.2c.5 0 .9 .1 1.4 .2l-1.8 1.8c-2.1 .2-3.8 1.7-4.3 3.7c-0.1 .3-0.3 .6-0.6 .7c-0.3 .1-0.6 .1-0.9-0.1c-0.5-0.3-1-0.4-1.6-0.4c-1.6 0-2.9 1.3-2.9 2.9c0 .9 .5 1.8 1.2 2.3Zm4.9 .6h4.6c2.7 0 4.9-2.2 4.9-4.9c0-1.2-0.5-2.4-1.4-3.3Z" />
        </SvgIcon>
    );
}

export function StatusPendingIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M11.7 9.9c-0.3 .1-0.6 .1-0.9 .1h-6.6c-1.4 0-2.5-1.1-2.5-2.5c0-1.4 1.1-2.5 2.5-2.5c.4 0 .9 .1 1.3 .4c.2 .1 .5 .2 .8 .1c.2-0.1 .4-0.3 .5-0.6c.4-1.9 2.1-3.2 4-3.2c2.3 0 4.2 1.8 4.2 4.1c0 1-0.3 1.8-0.9 2.5h2c.4-0.7 .6-1.6 .6-2.5c0-3.2-2.7-5.8-5.9-5.8c-2.3 0-4.4 1.4-5.3 3.5c-0.4-0.1-0.9-0.2-1.3-0.2c-2.3 0-4.2 1.9-4.2 4.2c0 2.3 1.9 4.2 4.2 4.2h6.6c.3 0 .6-0.1 .9-0.1Zm5.8 7.6h-1.7v-2.5h.9c.9 0 1.6-0.8 1.6-1.7c0-0.9-0.7-1.6-1.6-1.6c-1 0-1.7 .7-1.7 1.6h-1.7c0-1.8 1.5-3.3 3.4-3.3c1.8 0 3.3 1.5 3.3 3.3c0 1.6-1.1 2.9-2.5 3.3Zm-0.8 2.5c.4 0 .8-0.4 .8-0.8c0-0.5-0.4-0.9-0.8-0.9c-0.5 0-0.9 .4-0.9 .9c0 .4 .4 .8 .9 .8Z" />
        </SvgIcon>
    );
}

export function StatusPreparingIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M8.3 10h-4.1c-1.4 0-2.5-1.1-2.5-2.5c0-1.4 1.1-2.5 2.5-2.5c.4 0 .9 .1 1.3 .4c.2 .1 .5 .2 .8 .1c.2-0.1 .4-0.3 .5-0.6c.4-1.9 2.1-3.2 4-3.2c2.3 0 4.2 1.8 4.2 4.1c0 1-0.3 1.8-0.9 2.5h2c.4-0.7 .6-1.6 .6-2.5c0-3.2-2.7-5.8-5.9-5.8c-2.3 0-4.4 1.4-5.3 3.5c-0.4-0.1-0.9-0.2-1.3-0.2c-2.3 0-4.2 1.9-4.2 4.2c0 2.3 1.9 4.2 4.2 4.2h4.1Zm6.7 0c1.3 0 2.6 .5 3.5 1.5l1.5-1.5v4.2h-4.2l1.5-1.5c-0.6-0.7-1.4-1-2.3-1c-1.8 0-3.3 1.5-3.3 3.3h-1.7c0-2.8 2.2-5 5-5Zm0 8.3c-0.9 0-1.7-0.3-2.3-1l1.5-1.5h-4.2v4.2l1.5-1.5c.9 1 2.2 1.5 3.5 1.5c2.8 0 5-2.2 5-5h-1.7c0 1.8-1.5 3.3-3.3 3.3Z" />
        </SvgIcon>
    );
}

export function StatusRebootIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M4.2 10h4.1v1.7h-4.1c-2.3 0-4.2-1.9-4.2-4.2c0-2.3 1.9-4.2 4.2-4.2c.4 0 .9 .1 1.3 .2c.9-2.1 3-3.5 5.3-3.5c3.2 0 5.9 2.6 5.9 5.8c0 .9-0.2 1.8-0.6 2.5h-2c.6-0.7 .9-1.5 .9-2.5c0-2.3-1.9-4.1-4.2-4.1c-1.9 0-3.6 1.3-4 3.2c-0.1 .3-0.3 .5-0.5 .6c-0.3 .1-0.6 0-0.8-0.1c-0.4-0.3-0.9-0.4-1.3-0.4c-1.4 0-2.5 1.1-2.5 2.5c0 1.4 1.1 2.5 2.5 2.5Zm5.8 5c0-2.8 2.2-5 5-5c2.8 0 5 2.2 5 5c0 2.8-2.2 5-5 5c-1.3 0-2.6-0.5-3.5-1.5l-1.5 1.5v-4.2h4.2l-1.6 1.6h.1c.6 .6 1.4 .9 2.3 .9c1.8 0 3.3-1.5 3.3-3.3c0-1.8-1.5-3.3-3.3-3.3c-1.8 0-3.3 1.5-3.3 3.3Z" />
        </SvgIcon>
    );
}

export function StatusReservedIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M10 10h-5.8c-1.4 0-2.5-1.1-2.5-2.5c0-1.4 1.1-2.5 2.5-2.5c.4 0 .9 .1 1.3 .4c.2 .1 .5 .2 .8 .1c.2-0.1 .4-0.3 .5-0.6c.4-1.9 2.1-3.2 4-3.2c2.3 0 4.2 1.8 4.2 4.1c0 .6-0.1 1.2-0.4 1.7h1.8c.2-0.5 .3-1.1 .3-1.7c0-3.2-2.6-5.8-5.9-5.8c-2.3 0-4.4 1.4-5.3 3.5c-0.4-0.1-0.9-0.2-1.3-0.2c-2.3 0-4.2 1.9-4.2 4.2c0 2.3 1.9 4.2 4.2 4.2h5.8Zm9.2 2.5c0-1.8-1.5-3.3-3.4-3.3c-1.8 0-3.3 1.5-3.3 3.3c-0.5 0-0.8 .4-0.8 .8v5.9c0 .4 .3 .8 .8 .8h6.7c.4 0 .8-0.4 .8-0.8v-5.9c0-0.4-0.4-0.8-0.8-0.8Zm-3.4-1.7c1 0 1.7 .8 1.7 1.7h-3.3c0-0.9 .7-1.7 1.6-1.7Zm-2.5 7.5v-4.1h5v4.1Zm2.5-1.6c.5 0 .9-0.4 .9-0.9c0-0.4-0.4-0.8-0.9-0.8c-0.4 0-0.8 .4-0.8 .8c0 .5 .4 .9 .8 .9Z" />
        </SvgIcon>
    );
}

export function UserIndividualIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path
                d="M5.5 6c-1.7 0-3-1.3-3-3c0-1.7 1.3-3 3-3c1.7 0 3 1.3 3 3c0 1.7-1.3 3-3 3Zm0 0c2.8 0 5 2.2 5 5v3c0 .6-0.4 1-1 1h-1v4c0 .6-0.4 1-1 1h-4c-0.6 0-1-0.4-1-1v-4h-1c-0.6 0-1-0.4-1-1v-3c0-2.8 2.2-5 5-5Zm14-2l-7-3v19h2v-13.9Zm-14-2c-0.6 0-1 .4-1 1c0 .6 .4 1 1 1c.6 0 1-0.4 1-1c0-0.6-0.4-1-1-1Zm1 12v4h-2v-4c0-0.6-0.4-1-1-1h-1v-2c0-1.7 1.3-3 3-3c1.7 0 3 1.3 3 3v2h-1c-0.6 0-1 .4-1 1Z"
                fillRule="evenodd"
            />
        </SvgIcon>
    );
}

export function UserBusinessIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M3 19c0 .5 .4 1 1 1h12c.6 0 1-0.5 1-1v-7h1c.8 0 1.5-0.5 1.8-1.3c.4-0.7 .2-1.6-0.4-2.1l-8-8c-0.4-0.4-0.9-0.6-1.4-0.6c-0.5 0-1 .2-1.4 .6l-8 8c-0.6 .5-0.8 1.4-0.4 2.1c.3 .8 1 1.3 1.8 1.3h1Zm12-1h-10v-7c0-0.6-0.4-1-1-1h-2l8-8l8 8h-2c-0.6 0-1 .4-1 1Zm-3-7c0 1.1-0.9 2-2 2c-1.1 0-2-0.9-2-2c0-1.1 .9-2 2-2c1.1 0 2 .9 2 2Zm-5 6c0-1.9 1.2-3 3-3c1.8 0 3 1.1 3 3Z" />
        </SvgIcon>
    );
}

export function UserCSOIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M19.1 8.2c.4 0 .8-0.3 .9-0.7c.1-0.4-0.1-0.8-0.4-1l-9.1-5.5c-0.3-0.1-0.7-0.1-1 0l-9.1 5.5c-0.3 .2-0.5 .6-0.4 1c.1 .4 .5 .7 .9 .7Zm-9.1-5.3l5.8 3.5h-11.6Zm9.1 6.2v1.8h-0.9v3.6h.9v1.9h-18.2v-1.9h.9v-3.6h-0.9v-1.8Zm-13.6 1.8h-1.9v3.6h1.9Zm1.8 3.6h1.8v-3.6h-1.8Zm5.4-3.6h-1.8v3.6h1.8Zm1.8 3.6h1.9v-3.6h-1.9Zm5.5 4.6v-1.8h-20v1.8Z" />
        </SvgIcon>
    );
}

export function VisaIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M1.7 2.5h16.6c1 0 1.7 .7 1.7 1.7v11.6c0 1-0.7 1.7-1.7 1.7h-16.6c-1 0-1.7-0.7-1.7-1.7v-11.6c0-1 .7-1.7 1.7-1.7Zm0 13.3h16.6v-11.6h-16.6Zm3.8-3.6l-0.8-3.3h-1.4v-1.1h2.3l.5 2.1l.5-2.1h1.2l-1.1 4.4Zm2.8-3.3v2.2h-0.5v1.1h4.1c.8 0 1.4-0.6 1.4-1.4v1.4h1.1v-1.1h1.2v1.1h1.1v-2.8c0-0.9-0.8-1.6-1.7-1.6c-0.9 0-1.7 .7-1.7 1.6v1.4c0-0.7-0.6-1.4-1.4-1.4h-0.5c-0.2 0-0.3-0.1-0.3-0.2c0-0.2 .1-0.3 .3-0.3h1.9v-1.1h-1.9c-0.8 0-1.4 .6-1.4 1.4c0 .7 .6 1.4 1.4 1.4h.5c.2 0 .3 .1 .3 .2c0 .2-0.1 .3-0.3 .3h-2.5v-2.2h.6v-1.1h-2.2v1.1Zm6.7 0c-0.3 0-0.6 .2-0.6 .5v.6h1.2v-0.6c0-0.3-0.3-0.5-0.6-0.5Z" />
        </SvgIcon>
    );
}

export function MastercardIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M18.3 1.5h-16.6c-1 0-1.7 .7-1.7 1.7v11.6c0 1 .7 1.7 1.7 1.7h16.6c1 0 1.7-0.7 1.7-1.7v-11.6c0-1-0.7-1.7-1.7-1.7Zm0 13.3h-16.6v-11.6h16.6Zm-10.8-0.8c.9 0 1.8-0.2 2.5-0.7c.7 .4 1.6 .7 2.5 .7c2.8 0 5-2.2 5-5c0-2.8-2.2-5-5-5c-0.9 0-1.8 .3-2.5 .7c-0.7-0.5-1.6-0.7-2.5-0.7c-2.8 0-5 2.2-5 5c0 2.8 2.2 5 5 5Zm-3.2-5.8h1.5v1.6h1.7v1.7h1.7v-1.7h-1.7v-1.6h1.7v-1.7h-1.7v-0.8c.6 0 1.2 .1 1.7 .4v.4h.5c.5 .4 .8 1 1 1.7h-1.5v1.6h1.5c-0.2 .7-0.5 1.3-1 1.7h-0.5v.4c-0.5 .3-1.1 .4-1.7 .4v-0.8h-1.7v-1.7h-1.5c-0.1-0.2-0.1-0.5-0.1-0.8c0-0.3 0-0.6 .1-0.8Zm1.5 3.3v.4c-0.2-0.1-0.3-0.3-0.5-0.4Zm0-5h1.7v1.7h-1.7Zm0 0h-0.5c.2-0.1 .3-0.3 .5-0.4Zm10 2.5c0 1.8-1.5 3.3-3.3 3.3c-0.4 0-0.8 0-1.1-0.2c.7-0.8 1.1-1.9 1.1-3.1c0-1.2-0.4-2.3-1.1-3.1c.3-0.2 .7-0.2 1.1-0.2c1.8 0 3.3 1.5 3.3 3.3Z" />
        </SvgIcon>
    );
}

export function DefaultCardIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M1.7 2.5h16.6c1 0 1.7 .7 1.7 1.7v11.6c0 1-0.7 1.7-1.7 1.7h-16.6c-1 0-1.7-0.7-1.7-1.7v-11.6c0-1 .7-1.7 1.7-1.7Zm0 13.3h16.6v-11.6h-16.6v2.8h16.6v1.3v1.3h-16.6Zm9.1-2.4h-8.1v1.4h8.1Z" />
        </SvgIcon>
    );
}

export function DisableIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M15 5v4c1.1 0 2 .9 2 2v7c0 1.1-0.9 2-2 2h-10c-1.1 0-2-0.9-2-2v-7c0-1.1 .9-2 2-2v-4c0-2.8 2.2-5 5-5c2.8 0 5 2.2 5 5Zm-5-3c-1.7 0-3 1.3-3 3v4h6v-4c0-1.7-1.3-3-3-3Zm-5 9v7h10v-7Zm2 5c.8 0 1.5-0.7 1.5-1.5c0-0.8-0.7-1.5-1.5-1.5c-0.8 0-1.5 .7-1.5 1.5c0 .8 .7 1.5 1.5 1.5Z" />
        </SvgIcon>
    );
}

export function EnableIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M7 9h8c1.1 0 2 .9 2 2v7c0 1.1-0.9 2-2 2h-10c-1.1 0-2-0.9-2-2v-7c0-1.1 .9-2 2-2v-4c0-2.8 2.2-5 5-5c2.8 0 5 2.2 5 5v1h-2v-1c0-1.7-1.3-3-3-3c-1.7 0-3 1.3-3 3Zm-2 2v7h10v-7Zm.5 3.5c0-0.8 .7-1.5 1.5-1.5c.8 0 1.5 .7 1.5 1.5c0 .8-0.7 1.5-1.5 1.5c-0.8 0-1.5-0.7-1.5-1.5Z" />
        </SvgIcon>
    );
}

export function PayoffsIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M17.6 10.5h-1.9v-8.6h-11.4v8.6h-1.9v-10.5h15.2Zm-8-4.4h2.7v-1.5h-1.5v-0.8h-1.6v.8c-0.8 .2-1.5 1-1.5 1.9c0 1 .9 1.9 1.9 1.9h.8c.2 0 .4 .2 .4 .4c0 .2-0.2 .3-0.4 .3h-2.7v1.6h1.5v.7h1.6v-0.8c.8-0.1 1.5-0.9 1.5-1.8c0-1.1-0.9-1.9-1.9-1.9h-0.8c-0.2 0-0.4-0.2-0.4-0.4c0-0.2 .2-0.4 .4-0.4Zm-8.2 13.9h17.2c.5 0 .9-0.4 .9-1v-5.7c0-0.5-0.4-0.9-0.9-0.9h-4.8c-0.2 0-0.5 .1-0.7 .3l-1.6 1.6h-3l-1.6-1.6c-0.2-0.2-0.5-0.3-0.7-0.3h-4.8c-0.5 0-0.9 .4-0.9 .9v5.7c0 .6 .4 1 .9 1Zm16.2-1.9h-15.2v-3.8h3.4l1.6 1.6c.2 .2 .4 .3 .7 .3h3.8c.3 0 .5-0.1 .7-0.3l1.6-1.6h3.4Z" />
        </SvgIcon>
    );
}

export function EmployeesIcon(props: SvgIconProps) {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path d="M18.1 9c.1 .6 .2 1.2 .4 1.8c0 .3 0 .6-0.2 .8c-0.2 .3-0.5 .4-0.8 .4h-1v3c0 1.1-0.9 2-2 2h-1v2c0 .6-0.4 1-1 1h-10c-0.6 0-1-0.4-1-1v-11c0-4.4 3.6-8 8-8c6.5 0 7.5 4.6 8.6 9Zm-3.6 2c0-0.6 .4-1 1-1h.7c0-0.2 0-0.4-0.1-0.5c-1.1-4.9-1.9-7.5-6.6-7.5c-3.3 0-6 2.7-6 6v10h8v-2c0-0.6 .4-1 1-1h2Zm-10 0l5-7v5h3l-5 7v-5Z" />
        </SvgIcon>
    );
}

const icons = [
    { name: "CloseIcon", component: CloseIcon },
    { name: "StarIcon", component: StarIcon },
    { name: "InfoIcon", component: InfoIcon },
    { name: "WarningIcon", component: WarningIcon },
    { name: "SuccessIcon", component: SuccessIcon },
    { name: "ErrorIcon", component: ErrorIcon },
    { name: "CheckboxIcon", component: CheckboxIcon },
    { name: "CheckboxCheckedIcon", component: CheckboxCheckedIcon },
    { name: "CheckboxIndeterminateIcon", component: CheckboxIndeterminateIcon },
    { name: "InputSelectIcon", component: InputSelectIcon },
    { name: "TreeViewCollapseIcon", component: TreeViewCollapseIcon },
    { name: "TreeViewExpandIcon", component: TreeViewExpandIcon },
    { name: "TreeViewEndIcon", component: TreeViewEndIcon },
    { name: "AccountBillingIcon", component: AccountBillingIcon },
    { name: "AlertIcon", component: AlertIcon },
    { name: "AlertAltIcon", component: AlertAltIcon },
    { name: "AvailableIcon", component: AvailableIcon },
    { name: "CancelReservationIcon", component: CancelReservationIcon },
    { name: "CancelSessionIcon", component: CancelSessionIcon },
    { name: "CheckIcon", component: CheckIcon },
    { name: "CheckInIcon", component: CheckInIcon },
    { name: "CompanyIcon", component: CompanyIcon },
    { name: "CopyIcon", component: CopyIcon },
    { name: "CopyAltIcon", component: CopyAltIcon },
    { name: "CopyPlusIcon", component: CopyPlusIcon },
    { name: "CupIcon", component: CupIcon },
    { name: "CustomerGroupsIcon", component: CustomerGroupsIcon },
    { name: "CustomersIcon", component: CustomersIcon },
    { name: "DashboardIcon", component: DashboardIcon },
    { name: "DeleteIcon", component: DeleteIcon },
    { name: "DetailsIcon", component: DetailsIcon },
    { name: "DiagnosticsIcon", component: DiagnosticsIcon },
    { name: "DownIcon", component: DownIcon },
    { name: "DownloadIcon", component: DownloadIcon },
    { name: "DuplicateIcon", component: DuplicateIcon },
    { name: "EditIcon", component: EditIcon },
    { name: "EnergyIcon", component: EnergyIcon },
    { name: "FilterIcon", component: FilterIcon },
    { name: "FirmwareIcon", component: FirmwareIcon },
    { name: "HardResetIcon", component: HardResetIcon },
    { name: "ImageIcon", component: ImageIcon },
    { name: "InfoAltIcon", component: InfoAltIcon },
    { name: "InvoicesIcon", component: InvoicesIcon },
    { name: "InvoicesDownloadIcon", component: InvoicesDownloadIcon },
    { name: "LinkIcon", component: LinkIcon },
    { name: "LocationIcon", component: LocationIcon },
    { name: "LoginIcon", component: LoginIcon },
    { name: "LogoutIcon", component: LogoutIcon },
    { name: "MakeReservationIcon", component: MakeReservationIcon },
    { name: "ManageIcon", component: ManageIcon },
    { name: "MergeIcon", component: MergeIcon },
    { name: "MinusIcon", component: MinusIcon },
    { name: "MoreVerticalIcon", component: MoreVerticalIcon },
    { name: "PayNowIcon", component: PayNowIcon },
    { name: "PlusIcon", component: PlusIcon },
    { name: "QRCodeIcon", component: QRCodeIcon },
    { name: "RfidDeleteIcon", component: RfidDeleteIcon },
    { name: "RfidUploadIcon", component: RfidUploadIcon },
    { name: "SearchIcon", component: SearchIcon },
    { name: "SessionsIcon", component: SessionsIcon },
    { name: "SettingsIcon", component: SettingsIcon },
    { name: "ShortcutIcon", component: ShortcutIcon },
    { name: "SoftResetIcon", component: SoftResetIcon },
    { name: "StartSessionIcon", component: StartSessionIcon },
    { name: "StationsAltIcon", component: StationsAltIcon },
    { name: "SubmissionsIcon", component: SubmissionsIcon },
    { name: "TariffsIcon", component: TariffsIcon },
    { name: "TimesIcon", component: TimesIcon },
    { name: "TriggerMessageIcon", component: TriggerMessageIcon },
    { name: "UnavailableIcon", component: UnavailableIcon },
    { name: "UnlockIcon", component: UnlockIcon },
    { name: "UnpaidBalanceIcon", component: UnpaidBalanceIcon },
    { name: "UpIcon", component: UpIcon },
    { name: "UsersIcon", component: UsersIcon },
    { name: "ReplaceIcon", component: ReplaceIcon },
    { name: "ListArrowIcon", component: ListArrowIcon },
    { name: "CloseCircleOutlineIcon", component: CloseCircleOutlineIcon },
    { name: "CheckCircleOutlineIcon", component: CheckCircleOutlineIcon },
    { name: "CautionIcon", component: CautionIcon },
    { name: "StatusAvailableIcon", component: StatusAvailableIcon },
    { name: "StatusChargingIcon", component: StatusChargingIcon },
    { name: "StatusIssueDetectedIcon", component: StatusIssueDetectedIcon },
    { name: "StatusSuspendedReservedIcon", component: StatusSuspendedReservedIcon },
    { name: "StatusUnavailableIcon", component: StatusUnavailableIcon },
    { name: "StatusFinishingIcon", component: StatusFinishingIcon },
    { name: "VisaIcon", component: VisaIcon },
    { name: "MastercardIcon", component: MastercardIcon },
    { name: "DefaultCardIcon", component: DefaultCardIcon },
    { name: "DisableIcon", component: DisableIcon },
    { name: "EnableIcon", component: EnableIcon },
    { name: "PayoffsIcon", component: PayoffsIcon },
    { name: "EmployeesIcon", component: EmployeesIcon },
];

export default function IconsList() {
    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: "repeat(8, minmax(100px, 1fr))",
                gap: 4,
                p: 4,
            }}
        >
            {icons.map((icon, index) => {
                const IconComponent = icon.component;
                return (
                    <Box key={index} sx={{ textAlign: "center" }}>
                        <IconComponent style={{ fontSize: 40 }} />
                        <Typography variant="body2" sx={{ mt: 1 }}>
                            {icon.name}
                        </Typography>
                    </Box>
                );
            })}
        </Box>
    );
}
